import { createFileRoute } from "@tanstack/react-router";
import KetamineTherapyForChronicPainPage from "@/pages/articles/KetamineTherapyForChronicPainPage";
export const Route = createFileRoute(
  "/ketamine-therapy-for-chronic-pain-a-powerful-solution",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Ketamine for Chronic Pain | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Ketamine therapy for chronic pain in Coral Springs, FL. Learn how IV ketamine may help CRPS, fibromyalgia, and neuropathic pain Free consultation available.",
        },
        {
          property: "og:title",
          content: "Ketamine for Chronic Pain | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Ketamine therapy for chronic pain in Coral Springs, FL. Learn how IV ketamine may help CRPS, fibromyalgia, and neuropathic pain Free consultation available.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/ketamine-therapy-for-chronic-pain-a-powerful-solution",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/ketamine-therapy-for-chronic-pain-a-powerful-solution",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <KetamineTherapyForChronicPainPage />;
}
